
/** ----------------------------------------------- START GULP STUFF ----------------------------------------------- **/


        /* -- HEADER -- */

        import  "head-scripts/lib/jquery-3.2.1.min.js";

        import  "head-scripts/lib/fwajax.js";

        import  "head-scripts/lib/gsap.min.js";

        import  "head-scripts/lib/ScrollMagic.js";

        import  "head-scripts/lib/animation.gsap.min.js";

        //import  "head-scripts/lib/debug.addIndicators.min.js";         //@note: missing file -> there is one in notused dir



        import  "head-scripts/lib/ScrollToPlugin.min.js";

        //import  "head-scripts/lib/TweenMax.min.js";                   //@note: missing file -> there is one in notused dir

        //import  "head-scripts/lib/*.js";                              //@note see below

        /* START ALL head-scripts/lib files */


            import "head-scripts/lib/Hammer.js";
            import "head-scripts/lib/ScrollMagic.js";
            import "head-scripts/lib/ScrollToPlugin.min.js";
            import "head-scripts/lib/adm_autocomplete.js";
            import "head-scripts/lib/animation.gsap.min.js";
            import "head-scripts/lib/bootstrap.js";
            import "head-scripts/lib/fwajax.js";
            import "head-scripts/lib/gsap.min.js";
            import "head-scripts/lib/jquery-3.2.1.min.js";
            import "head-scripts/lib/jquery-ui.js";
            import "head-scripts/lib/jquery.cookie.js";
            import "head-scripts/lib/jquery.easing.1.3.js";
            import "head-scripts/lib/jquery.fitvids.js";
            import "head-scripts/lib/jquery.googleMaps.js";
            import "head-scripts/lib/jquery.inview.js";
            import "head-scripts/lib/jquery.serializeObject.min.js";
            import "head-scripts/lib/jquery_cookie.js";
            import "head-scripts/lib/layout.engine.min.js";
            import "head-scripts/lib/mandatory_registration.js";
            import "head-scripts/lib/mnp.js";
            import "head-scripts/lib/photoswipe-ui-default.min.js";
            import "head-scripts/lib/photoswipe.min.js";
            import "head-scripts/lib/subscriber_request.js";
            import "head-scripts/lib/svgIcons.js";
            import "head-scripts/lib/svgicons-config.js";
            import "head-scripts/lib/swiper.min.js";
            import "head-scripts/lib/transfer_subscriber_request.js";
            import "head-scripts/lib/underscore-min.js";
            import "head-scripts/lib/zquantitymatrix.js";




        /* END ALL head-scripts/lib files */


        import  "head-scripts/head-app-specific.js";



        /* -- FOOTER -- */


        //import  "footer-scripts/lib/ScrollMagic.js";                      //@note missing file - there is one in head-scripts/lib tho

        //import  "footer-scripts/lib/animation.gsap.min.js";               //@note missing file - there is one in head-scripts/lib


        //import  "footer-scripts/lib/*.js"                                 //@note see below

        /* START ALL footer-scripts/lib files */

            import "footer-scripts/lib/jquery.hoverIntent.min.js";
            import "footer-scripts/lib/jquery.menu-aim.js";

        /* END ALL footer-scripts/lib files */


        import  "footer-scripts/footer-app-specific.js";

        //import  "footer-scripts/mnp.js";                                  //@note missing file - there is one in head/scripts/lib


/** ----------------------------------------------- END GULP STUFF ------------------------------------------------- **/























//import '../../scss/master.scss';

// import JQuery from 'jquery';

// for Vue
// window.$ = window.JQuery = JQuery;

$(document).ready(function() {
	console.log('App 2025 ready!');
});


// import Headroom from "headroom.js";


// import Swiper from 'swiper';
// import { Autoplay, Navigation, Pagination, Scrollbar } from 'swiper/modules';
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';
// import 'swiper/css/autoplay';

// import MicroModal from 'micromodal';


import { animate } from "motion";



// https://davidwalsh.name/javascript-debounce-function
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.

function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
}





function headerNav() {
	const isMobile = window.innerWidth <= 992;

	if (isMobile) {
		$(".primary-menu").attr('aria-hidden', 'true').hide();
	} else {
		$(".primary-menu").attr('aria-hidden', 'false').show();
	}

}


function headerNavToggle() {
	const $menu = $('.primary-menu');

	$(".js-main-menu-toggle").click(function (e) {
		// console.log("js-main-menu-toggle click");
		e.preventDefault();
		if ($(this).hasClass("is-active")) {
			$(this).removeClass("is-active");
			$(this).attr('aria-expanded', 'false');
			$(this).attr('aria-label', 'Otvori navigaciju');
			$menu.removeClass("is-active");
			$menu.attr('aria-hidden', 'true').hide();
			$(".website-header").removeClass("is-fixed");
			$(".nav-dropdown-menu").removeClass("is-active");
			$menu.removeClass("is-pushed");
			$menu.removeClass("is-pushed-level-2");
		} else {
			$(this).addClass("is-active");
			$(this).attr('aria-expanded', 'true');
			$(this).attr('aria-label', 'Zatvori navigaciju');
			$menu.addClass("is-active");
			$menu.attr('aria-hidden', 'false').show();

			// Inject focus trap link (only once)
			if (!$menu.find('.menu-focus-back').length) {
				$menu.prepend('<a href="#" class="menu-focus-back visually-hidden" aria-hidden="true">Natrag na gumb za navigaciju</a>');
			}

			// Handle reverse focus from first item
			$menu.find('.menu-focus-back').on('focus', function () {
				$(".js-main-menu-toggle").focus();
			});
			const $firstLink = $(".primary-menu").find('a').not('.menu-focus-back').first();
			if ($firstLink.length) {
				$firstLink.focus();
			}
			$(".website-header").addClass("is-fixed");
		}
	});

}

/****************
	Navigation
****************/

function headerDropdownToggleAnimation() {
  // Track animation state globally
  let isAnimating = false;

  // Select all dropdown toggle buttons
  const toggleButtons = document.querySelectorAll('.js-nav-dropdown-menu-toggle');

  // Track the currently animated items
  let currentlyAnimatedItems = [];

  // Function to check if we should animate (screen width < 992px)
  function shouldAnimate() {
    return window.innerWidth < 992;
  }

  // Function to close all open dropdowns
  function closeAllDropdowns() {
    document.querySelectorAll('.js-nav-dropdown-menu-toggle[aria-expanded="true"]').forEach(openButton => {
      openButton.setAttribute('aria-expanded', 'false');
      openButton.classList.remove('is-active');

      const openParentItem = openButton.closest('.js-drop');
      const openDropdown = openParentItem.querySelector('.nav-dropdown-menu');
      openDropdown.classList.remove('is-active');

      if (shouldAnimate()) {
        // For small screens, handle with animation cleanup
        openDropdown.style.display = 'none';
        openDropdown.style.removeProperty('height');
        openDropdown.style.removeProperty('opacity');
      } else {
        // For large screens, just hide
        openDropdown.style.display = 'none';
      }

      // Remove active class from main menu item
      const openMainMenuItem = openParentItem.querySelector('.primary-menu__sub-item');
      if (openMainMenuItem) {
        openMainMenuItem.classList.remove('is-active');
      }
    });

    // Reset any animated items
    if (currentlyAnimatedItems.length > 0) {
      currentlyAnimatedItems.forEach(item => {
        item.style.transform = 'translateY(0)';
      });
      currentlyAnimatedItems = [];
    }

    isAnimating = false;
  }

  // Add click event listener to each button
  toggleButtons.forEach(button => {
    button.addEventListener('click', function(event) {
      // Prevent default behavior
      event.preventDefault();

      // Stop event propagation to prevent bubbling issues
      event.stopPropagation();

      // Get the parent list item
      const parentItem = this.closest('.js-drop');

      // Get the dropdown menu
      const dropdownMenu = parentItem.querySelector('.nav-dropdown-menu');

      // Get all list items that come after this parent item
      const nextItems = [];
      let nextSibling = parentItem.nextElementSibling;
      while (nextSibling) {
        if (nextSibling.classList.contains('primary-menu__item')) {
          nextItems.push(nextSibling);
        }
        nextSibling = nextSibling.nextElementSibling;
      }

      // Reset any previously animated items to y: 0
      if (currentlyAnimatedItems.length > 0) {
        currentlyAnimatedItems.forEach(item => {
          // Immediately reset position without animation
          item.style.transform = 'translateY(0)';
        });
        // Clear the array
        currentlyAnimatedItems = [];
      }

      // Store the new items being animated
      currentlyAnimatedItems = [...nextItems];

      // Don't process clicks during animation
      if (isAnimating && shouldAnimate()) return;

      // Only set animating flag if we're on small screens
      if (shouldAnimate()) {
        isAnimating = true;
      }

      // Get current button state
      const isExpanded = this.getAttribute('aria-expanded') === 'true';

      // Handle class toggling (from headerDropdownToggle)
      if (isExpanded) {
        // Remove active classes when closing
        this.classList.remove('is-active');
        dropdownMenu.classList.remove('is-active');
        const mainMenuItem = parentItem.querySelector('.primary-menu__sub-item');
        if (mainMenuItem) {
          mainMenuItem.classList.remove('is-active');
        }
      } else {
        // Remove active classes from all elements
        document.querySelectorAll('.js-nav-dropdown-menu-toggle').forEach(btn => {
          btn.classList.remove('is-active');
          btn.classList.remove('js-toggle-rotate');
        });

        document.querySelectorAll('.nav-dropdown-menu').forEach(menu => {
          menu.classList.remove('is-active');
        });

        document.querySelectorAll('.primary-menu__sub-item').forEach(item => {
          item.classList.remove('is-active');
        });

        // Add active classes to current elements
        this.classList.add('is-active');
        dropdownMenu.classList.add('is-active');
        const mainMenuItem = parentItem.querySelector('.primary-menu__sub-item');
        if (mainMenuItem) {
          mainMenuItem.classList.add('is-active');
        }
      }

      // Close ALL other dropdowns first, regardless of DOM order
      document.querySelectorAll('.js-nav-dropdown-menu-toggle[aria-expanded="true"]').forEach(openButton => {
        if (openButton !== this) {
          openButton.setAttribute('aria-expanded', 'false');
          openButton.classList.remove('is-active');

          const openParentItem = openButton.closest('.js-drop');
          const openDropdown = openParentItem.querySelector('.nav-dropdown-menu');
          openDropdown.classList.remove('is-active');

          if (shouldAnimate()) {
            // For small screens, handle with animation cleanup
            openDropdown.style.display = 'none';
            openDropdown.style.removeProperty('height');
            openDropdown.style.removeProperty('opacity');
          } else {
            // For large screens, just hide
            openDropdown.style.display = 'none';
          }

          // Remove active class from main menu item
          const openMainMenuItem = openParentItem.querySelector('.primary-menu__sub-item');
          if (openMainMenuItem) {
            openMainMenuItem.classList.remove('is-active');
          }
        }
      });

      // Toggle current dropdown
      this.setAttribute('aria-expanded', !isExpanded);

      if (isExpanded) {
        if (shouldAnimate()) {
          // Small screens - animate closing
          animate(dropdownMenu, { opacity: 0, height: 0 }, {
            type: "spring",
            mass: 1,
            stiffness: 300,
            damping: 20
          }).then(() => {
            dropdownMenu.style.display = 'none';
            dropdownMenu.style.height = 'auto';
            dropdownMenu.style.opacity = 0;
            isAnimating = false;
          });

          // Animate list items back to original position
          nextItems.forEach(item => {
            animate(item, { y: 0 }, {
              type: "spring",
              mass: 1,
              stiffness: 300,
              damping: 20
            });
          });
        } else {
          // Large screens - just hide
          dropdownMenu.style.display = 'none';
        }
      } else {
        if (shouldAnimate()) {
          // Small screens - animate opening
          dropdownMenu.style.height = 'auto';
          dropdownMenu.style.opacity = 0;
          dropdownMenu.style.display = 'block';
          const height = dropdownMenu.offsetHeight;
          dropdownMenu.style.height = '0px';

          animate(dropdownMenu, { opacity: 1, height }, {
            type: "spring",
            mass: 1,
            stiffness: 300,
            damping: 20
          }).then(() => {
            isAnimating = false;
          });

          // Animate list items below
          nextItems.forEach(item => {
            animate(item, { y: height }, {
              type: "spring",
              mass: 1,
              stiffness: 300,
              damping: 20
            });
          });
        } else {
          // Large screens - just show
          dropdownMenu.style.display = 'block';
        }
      }
    });
  });

  // Add click event listener to document to close dropdowns when clicking outside
  document.addEventListener('click', function(event) {
    // Only handle this for desktop views
    if (!shouldAnimate()) {
      // Check if any dropdown is open
      const openDropdowns = document.querySelectorAll('.js-nav-dropdown-menu-toggle[aria-expanded="true"]');
      if (openDropdowns.length > 0) {
        // Check if the click was outside the navigation
        const mainMenu = document.querySelector('.primary-menu');
        if (mainMenu && !mainMenu.contains(event.target)) {
          closeAllDropdowns();
        }
      }
    }
  });

  // Handle window resize to reset any animations in progress
  window.addEventListener('resize', function() {
    if (!shouldAnimate() && currentlyAnimatedItems.length > 0) {
      currentlyAnimatedItems.forEach(item => {
        item.style.transform = 'translateY(0)';
      });
      currentlyAnimatedItems = [];

      // Reset any open dropdowns to use non-animated styles
      document.querySelectorAll('.nav-dropdown-menu.is-active').forEach(menu => {
        menu.style.removeProperty('height');
        menu.style.removeProperty('opacity');
        menu.style.display = 'block';
      });

      isAnimating = false;
    }
  });
}



var bannerSlider = {

	element: '.banner-slider',

	firstLoad: true,
	swiperSecond: undefined,
	map: [],
	tabs: [],
	fixedHeight: 380,


	init: function () {
		var self = this;

		if (jQuery('.banner-slider').length === 0) {
			return;
		}


		this.initSelector();

	},

	initSelector: function () {

		var self = this;

		/*var sliderContents = jQuery('.banner-slider-content .hero-img');
		sliderContents.removeClass('fadeInDown');*/

		//console.log('setup desktop');
		self.swiperSecond = new Swiper('.banner-slider-content', {
			//spaceBetween: 10,
			speed: 500,

			navigation: {
				//nextEl: '.banner-slider .swiper-button-next',
				//prevEl: '.banner-slider .swiper-button-prev',
			},
			//nextButton: '.banner-slider .swiper-button-next',
			//prevButton: '.banner-slider .swiper-button-prev',
			// pagination: '.banner-slider .swiper-pagination',
			// paginationType: 'fraction',
			loop: false,
			autoplay: 3000,
			pagination: {
				//el: '.banner-slider .swiper-pagination',
			},
			paginationClickable: true,
			slidesPerView: "auto",
			spaceBetween: 30,


			breakpoints: {
				// when window width is <= 320px
				767: {
                    spaceBetween: 30,
					slidesPerView: 1.2
				}
			},
			onInit: function (swiper) {
				/*self.desktopSetActivTab();*/


			},
			onSlideChangeStart: function (swiper) {

			},
			onTransitionStart: function (swiper) {

			},
		});

		/*console.log('slider initialized');*/

	},

};






/////	Homepage tabs
// function initTabs(appSelector = '[data-tabs-app]') {
// 	const app = document.querySelector(appSelector);
// 	if (!app) return;

// 	const triggers = app.querySelectorAll('[data-tabs-trigger]');
// 	const targets = app.querySelectorAll('[data-tabs-target]');

// 	triggers.forEach((trigger, index) => {
// 		trigger.addEventListener('click', () => {
//       console.log("clicked")
// 			// Reset all triggers and targets
// 			triggers.forEach(t => t.setAttribute('data-tabs-trigger', ''));
// 			targets.forEach(t => t.setAttribute('data-tabs-target', ''));

// 			// Activate clicked trigger and corresponding target
// 			trigger.setAttribute('data-tabs-trigger', 'active');
// 			if (targets[index]) {
// 				targets[index].setAttribute('data-tabs-target', 'active');
// 			}
// 		});
// 	});
// }


// home tabs pretplata/bonovi - eaa enhanced
function homepagePretplataBonoviTabs() {
  $('.home-tabs__btn[data-tab]').on('click', function () {
    var tabId = $(this).data('tab');

    // 1. Deactivate all tabs
    $('.home-tabs__btn')
      .removeAttr('data-tabs-trigger')
      // .attr('aria-selected', 'false')
      // .attr('tabindex', '-1');

    $('[data-tabs-target]').each(function () {
      $(this)
        .removeAttr('data-tabs-target')
        .attr('aria-hidden', 'true')
        // .attr('tabindex', '-1');
    });

    // 2. Activate selected tab
    $(this)
      .attr('data-tabs-trigger', 'active')
      // .attr('aria-selected', 'true')
      // .attr('tabindex', '0')
      .focus();

    // 3. Show matching panel
    $('[data-tab="' + tabId + '"]')
      .attr('data-tabs-target', 'active')
      .attr('aria-hidden', 'false')
      // .attr('tabindex', '0');
  });

  // Set default tab on load
  // $('.home-tabs__btn[data-tab="pretplata"]').click();
}




// screen reader fix for broken/slow price reading | croatia localized
// add or fixes aria labels for prices in croatian locale
document.querySelectorAll('[class*="price"], [class*="amount"], [class*="cijena"]').forEach(function(el) {
  let text = el.textContent.trim().replace(/\s+/g, ' ');

  // Match numbers and currency (EUR or €)
  const match = text.match(/([\d,.]+)\s*(EUR|€)/i);
  if (match) {
    let amountStr = match[1].replace(',', '.'); // Convert comma to dot for parsing
    let currency = match[2].toUpperCase();

    let amount = parseFloat(amountStr);
    if (!isNaN(amount)) {
      // Format the number in Croatian (hr-HR) locale
      let localizedAmount = new Intl.NumberFormat('hr-HR', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);

      // Build aria-label: "8,00 eura"
      let ariaLabel = `${localizedAmount} eura`;
      el.setAttribute('aria-label', ariaLabel);
    }
  }
});


// fix for "100 GB", "500 SMS", "60 min" - add aria-labels
document.querySelectorAll('[class*="price"], [class*="amount"], [class*="cijena"], li, span, div, p')
  .forEach(function(el) {
    const text = el.textContent.trim();

    // Match patterns like "100 GB", "500 SMS", "60 min"
    const match = text.match(/(\d+)[\s\u00A0]*(GB|SMS|min)\b/i);
    if (match) {
      const number = match[1];
      const unit = match[2].toLowerCase();
      let label = '';

      if (unit === 'gb') {
        label = `${number} gigabajta`;
      } else if (unit === 'sms') {
        label = `${number} SMS poruka`;
      } else if (unit === 'min') {
        label = `${number} minuta`;
      }

      // Set aria-label only if not already present
      if (!el.hasAttribute('aria-label')) {
        el.setAttribute('aria-label', label);
      }
    }
  });









/* GDPR 2025 - Enhanced with Full Accessibility */
var VuduGdprPlugin = {
  options: {
    'necessary': {
      cookieName: 'gdpr_level_1_necessary',
      pristine: true,
      disabled: true,
      checked: true,
      el: 'gdpr_settings_choice_necessary',
      current: null,
    },
    'analytical': {
      cookieName: 'gdpr_level_2_analytical',
      pristine: true,
      disabled: false,
      checked: false,
      el: 'gdpr_settings_choice_analytical',
      current: null,
    },
    'marketing': {
      cookieName: 'gdpr_level_3_marketing',
      pristine: true,
      disabled: false,
      checked: false,
      el: 'gdpr_settings_choice_marketing',
      current: null,
    }
  },

  init: function () {
    if ($('#gdpr_toolbar').length) {
      this.bindEvent();

      let pristine = true;
      for (let i in this.options) {
        const opt = this.options[i];
        const val = this.getCookie(opt.cookieName);
        if (val == 1) {
          pristine = false;
          if (!opt.disabled) {
            opt.checked = true;
            $("#" + opt.el).prop("checked", true);
          }
        } else if (val == 0) {
          pristine = false;
          if (!opt.disabled) {
            opt.checked = false;
            $("#" + opt.el).prop("checked", false);
          }
        }
      }

      if (!pristine) {
        $("#js-toogle-gdpr").addClass("show");
        this.hideToolbar();
        $('#gdpr_toolbar').attr('aria-hidden', "true");
        $('#cookie_policy_apendix').attr('aria-hidden', "true");
      } else {
        $("#gdpr_toolbar").removeClass("hide");
        $('#gdpr_toolbar').attr('aria-hidden', "false");
        $('#cookie_policy_apendix').attr('aria-hidden', "false");
      }
    }
  },

  sendGTM: function () {
    window.dataLayer = window.dataLayer || [];
    const marketingGranted = this.options.marketing.current === true;
    const analyticsGranted = this.options.analytical.current === true;
    const obj = {
      event: 'consentDataLayer',
      ad_storage: marketingGranted ? 'granted' : 'denied',
      ad_user_data: marketingGranted ? 'granted' : 'denied',
      ad_personalization: marketingGranted ? 'granted' : 'denied',
      analytics_storage: analyticsGranted ? 'granted' : 'denied',
      personalization_storage: marketingGranted ? 'granted' : 'denied',
      functionality_storage: 'granted',
      security_storage: 'granted'
    };
    window.dataLayer.push(obj);
    console.log(obj);
  },

  bindEvent: function () {
    const modal = document.getElementById("gdpr_settings_popup");
    const mainContent = document.querySelector("main, body");

    $('#gdpr_toolbar .x_submit_necessary').on("click", function (e) {
      e.preventDefault();
      VuduGdprPlugin._setMinimalConsent();
    });

    $('#gdpr_toolbar .x_submit_all').on("click", function (e) {
      e.preventDefault();
      for (let level in VuduGdprPlugin.options) {
        const opt = VuduGdprPlugin.options[level];
        VuduGdprPlugin.consentCookie(level, true);
        $("#" + opt.el).prop("checked", true);
      }
      VuduGdprPlugin.finishConsent();
    });

    $('#gdpr_toolbar .x_open_setup').on("click", function (e) {
      e.preventDefault();

      $('#gdpr_toolbar .gdpr-controls').addClass('active');
      $(this).addClass('active');
      $('#gdpr_settings_popup').addClass('is-visible');
      $('.gdpr-intro').addClass('is-hidden');

      VuduGdprPlugin._lastFocused = document.activeElement;

      // mainContent?.setAttribute('inert', '');
      // mainContent?.setAttribute('aria-hidden', 'true');

      const focusable = modal.querySelectorAll("button, [href], input, select, textarea, [tabindex]:not([tabindex='-1'])");
      if (focusable.length) {
        setTimeout(() => focusable[0].focus(), 100);
      }

      trapFocus(modal);
    });

    $('#js-toogle-gdpr').on("click", function (e) {
      e.preventDefault();
      $('#gdpr_toolbar .gdpr-controls').removeClass('active');
      $('#gdpr_toolbar').attr('aria-hidden', "false");
      $('#cookie_policy_apendix').attr('aria-hidden', "false");
      VuduGdprPlugin.showToolbar();
    });

    $("#gdpr_toolbar .x_submit_selected").on("click", function (e) {
      e.preventDefault();
      $("#gdpr_toolbar input.gdpr_level").each(function () {
        VuduGdprPlugin.consentCookie($(this).val(), $(this).prop("checked"));
      });
      VuduGdprPlugin.finishConsent();
    });

    $('.partners-modal-link').click(function (e) {
      e.preventDefault();
      $('#cookie_policy_apendix').addClass('show');
    });

    $('.js-close-partners-modal').click(function (e) {
      e.preventDefault();
      $('#cookie_policy_apendix').removeClass('show');
    });

    $(document).on("keydown", function (e) {
      if (e.key === "Escape" && $('#gdpr_settings_popup').hasClass("is-visible")) {
        VuduGdprPlugin._closeSettingsPopup();
      }
    });
  },

  _closeSettingsPopup: function () {
    $('#gdpr_settings_popup').removeClass("is-visible");
    $('.gdpr-intro').removeClass("is-hidden");
    $("#gdpr-overlay").hide();
    this.hideGdprToolbar();

    const mainContent = document.querySelector("main, body");
    mainContent?.removeAttribute('inert');
    mainContent?.setAttribute('aria-hidden', 'false');

    if (this._lastFocused) this._lastFocused.focus();
  },

  _setMinimalConsent: function () {
    this.consentCookie('necessary', true);
    this.consentCookie('analytical', false);
    this.consentCookie('marketing', false);
    $('#gdpr_settings_choice_necessary').prop("checked", true);
    $('#gdpr_settings_choice_analytical').prop("checked", false);
    $('#gdpr_settings_choice_marketing').prop("checked", false);
    this.finishConsent();
  },

  finishConsent: function () {
    this._closeSettingsPopup();
    $('#gdpr_toolbar').addClass("hide");
    $('#js-toogle-gdpr').addClass("show");
    $('#cookie_policy_apendix').attr('aria-hidden', "true");
    this.sendGTM();
  },

  showToolbar: function () {
    $("#gdpr-overlay").show();
    $("#gdpr_toolbar").removeClass('hide').css("display", "block");
    $('#gdpr_toolbar').attr('aria-hidden', "false");
  },

  hideToolbar: function () {
    const toolbar = document.getElementById("gdpr_toolbar");
    if (toolbar.contains(document.activeElement)) {
      const toggleBtn = document.getElementById("js-toogle-gdpr");
      toggleBtn?.focus();
    }
    $("#gdpr-overlay").hide();
    toolbar.setAttribute("aria-hidden", "true");
    toolbar.style.display = "none";
  },

  hideGdprToolbar: function () {
    const toolbar = document.getElementById("gdpr_toolbar");
    if (toolbar.contains(document.activeElement)) {
      document.activeElement.blur();
    }
    toolbar.setAttribute("aria-hidden", "true");
    toolbar.style.display = "none";
  },

  consentCookie: function (name, checked) {
    if (this.options[name]) {
      const value = checked ? 1 : 0;
      this.setCookie(this.options[name].cookieName, value, 365);
      this.options[name].current = checked;
    }
  },

  setCookie: function (cname, cvalue, exdays) {
    let d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    document.cookie = `${cname}=${cvalue};expires=${d.toUTCString()};path=/`;
  },

  getCookie: function (cname) {
    const name = cname + "=";
    const ca = decodeURIComponent(document.cookie).split(';');
    for (let c of ca) {
      while (c.charAt(0) == ' ') c = c.substring(1);
      if (c.indexOf(name) == 0) return c.substring(name.length);
    }
    return null;
  }
};

function trapFocus(modal) {
  const focusableEls = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
  const firstEl = focusableEls[0];
  const lastEl = focusableEls[focusableEls.length - 1];

  modal.addEventListener('keydown', e => {
    if (e.key === 'Tab') {
      if (e.shiftKey) {
        if (document.activeElement === firstEl) {
          e.preventDefault();
          lastEl.focus();
        }
      } else {
        if (document.activeElement === lastEl) {
          e.preventDefault();
          firstEl.focus();
        }
      }
    }
  });
}

document.querySelector('.gdpr-prompt__container')?.addEventListener('animationend', () => {
  const dialog = document.querySelector('#gdpr_toolbar dialog');
  const heading = dialog?.querySelector('h2');
  heading?.focus();
});











class CheckboxSwitch {
	constructor(domNode) {
		this.switchNode = domNode;
		this.switchNode.addEventListener('focus', () => this.onFocus(event));
		this.switchNode.addEventListener('blur', () => this.onBlur(event));
	}

	onFocus(event) {
		event.currentTarget.parentNode.classList.add('focus');
	}

	onBlur(event) {
		event.currentTarget.parentNode.classList.remove('focus');
	}
}

// Initialize switches
window.addEventListener('load', function () {
	// Initialize the Switch component on all matching DOM nodes
	Array.from(
		document.querySelectorAll('input[type=checkbox][role^=switch]')
	).forEach((element) => new CheckboxSwitch(element));



	// gdpr Modal
	const gdprModal = document.querySelector('.gdpr-prompt__container');
	const gdprIntro = document.querySelector('.gdpr-intro');
	const gdprOptions = document.querySelector('.gdpr-options');

	const gdprOptionsFirstLink = document.querySelector('#gdpr-options-first-link');

	const gdprSubmitAll = document.querySelector('.x_submit_all');

	const focusableElements = gdprModal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
	const firstElement = focusableElements[0];
	const lastElement = focusableElements[focusableElements.length - 1];
	// console.log('focusableElements', focusableElements)
	// console.log('firstElement', firstElement)
	// console.log('lastElement', lastElement)


	gdprModal.addEventListener('keydown', (e) => {
		if (e.key === 'Tab') {
			console.log('Tab', e.key)
			if (e.shiftKey && document.activeElement === firstElement) {
				e.preventDefault();
				lastElement.focus();
			} else if (!e.shiftKey && document.activeElement === lastElement) {
				e.preventDefault();
				// firstElement.focus();
				gdprSubmitAll.focus();

			}
		}
	});

	const beforeGuard = document.getElementById('focus-guard-before');
	const afterGuard = document.getElementById('focus-guard-after');

	beforeGuard.addEventListener('focus', () => {
		// console.log('beforeGuard');
		// lastElement.focus();
		// console.log('parent node', lastElement.closest('.gdpr-choice-details'))

		if (lastElement.closest('.gdpr-choice-details').hasAttribute('open')) {
			lastElement.focus();
		} else {
			lastElement.closest('.gdpr-choice-details').querySelector('.gdpr-choice-details__summary').focus();
		}
	});

	afterGuard.addEventListener('focus', () => {
		// console.log('afterGuard');
		// gdprSubmitAll.focus();

		if(gdprIntro.classList.contains('is-hidden')) {
			// console.log('gdpr intro je skriven');
			gdprSubmitAll.focus();
		} else {
			firstElement.focus();
		}

		// gdprModal.focus();
	});


});


/*function gdprReadMoreToggle() {
	$(".js-gdpr-read-more-toggle").click(function (e) {
		e.preventDefault();
		if ($(this).siblings(".gdpr-choice-details__content").hasClass("is-active")) {
			$(".gdpr-choice-details__content").removeClass("is-active");
			console.log($(this).parents(".main-menu__item"), "parent")
			$(this).removeClass("js-toggle-rotate");
			$(this).attr("aria-expanded","false");
		} else {
			$(".js-gdpr-read-more-toggle").removeClass("js-toggle-rotate");
			$(".gdpr-choice-details__content").removeClass("is-active");
			$(this).siblings(".gdpr-choice-details__content").addClass("is-active");
			$(this).addClass("js-toggle-rotate");
			$(this).attr("aria-expanded","true");
		}
	});
}*/

/* end gdpr 2025 */






/**
 * main domready handler
 */

$(document).ready(function() {

	headerNav();
	headerNavToggle();
	headerDropdownToggleAnimation();
	bannerSlider.init();

  homepagePretplataBonoviTabs();
	// initTabs();



  	/* GDPR 2025 */
	VuduGdprPlugin.init();

	//\\notice binding\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\
	noticeBlockControl.init();

});


/*window.onresize = function() {

	headerNav();

};*/

$(window).on('resize', debounce(function() {

	if ( $('.website-header').length ) {
		headerNav();
	}
	
}, 400));


// document.addEventListener("DOMContentLoaded", function() {




// });






/*import { interpolate } from "flubber";

const paths = {
        star: {
            color: "#D2A4FF",
            d: "M0 0 H360 V800 H0 Z",
        },
        heart: {
            color: "#021246",
            d: "M0 0 H360 V620 Q360 800 180 800 Q0 800 0 620 Z",
        },
    }

    const path = document.querySelector("#icon path")
    let currentPath = paths.star

    path.setAttribute("fill", currentPath.color)
    path.setAttribute("d", currentPath.d)

    function togglePath() {
        currentPath = currentPath === paths.star ? paths.heart : paths.star

        const mixPaths = interpolate(path.getAttribute("d"), currentPath.d, {
            maxSegmentLength: 0.1,
        })

        const duration = 0.5

        animate(path, { fill: currentPath.color }, { duration })
        animate(0, 1, {
            onUpdate: (progress) => path.setAttribute("d", mixPaths(progress)),
            duration,
        })
    }

    setInterval(togglePath, 1000)*/
